var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.85 7.171 9 9.114V.556C9 .249 8.776 0 8.5 0S8 .249 8 .556v8.526l-1.82-1.91a.52.52 0 0 0-.77 0 .617.617 0 0 0 0 .828l1.95 2.05a1.55 1.55 0 0 0 2.31 0L11.62 8a.617.617 0 0 0 0-.829.52.52 0 0 0-.77 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 10v3.006A1.995 1.995 0 0 1 14.006 15H3.01a1.995 1.995 0 0 1-1.994-1.994V10h1v3.006c0 .548.445.994.994.994h10.996a.995.995 0 0 0 .994-.994V10z"
  })));
};
export default SvgDownload;